import Equipe from "./Equipe";

export default class Diario {
  constructor(id, data, atividade, alteracao, km) {
    this.id = id;
    this.data = data;
    this.atividade = atividade;
    this.alteracao = alteracao;
    this.km = km;
    this.equipe = new Equipe(0, "", "", new Date(), "");
  }

  update(diario) {
    this.id = diario.id;
    this.data = diario.data;
    this.atividade = diario.atividade;
    this.alteracao = diario.alteracao;
    this.km = diario.km;
    this.equipe = diario.equipe;
  }
}